import React, { useEffect, useState } from "react";

import LoadingCenter from "../../LoadingCenter";
import ReactApexChart from "react-apexcharts";

import { useHttp } from "../../../hooks/useHttp";
import { useTheme } from "../../../hooks/useTheme";
import { useQuery } from "@tanstack/react-query";

let chart;

const ApexChartDailyCalls = props => {
  const request = useHttp();

  const { theme } = useTheme();

  const { isLoading } = useQuery(["calls"], () => request({ url: "/dash/graph/call", method: "GET" }), {
    onSuccess: calls => {
      const textColor = theme === "dark"
        ? "#FFFFFF"
        : "#323439";

      chart = <ReactApexChart options={{
        chart: {
          foreColor: textColor,
          color: textColor,
          textColor: textColor,
          type: "bar",
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
              foreColor: textColor,
              color: textColor,
              textColor: textColor,
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "12px",
                  fontWeight: 600,
                  foreColor: textColor,
                  color: textColor,
                  textColor: textColor,
                }
              }
            }
          },
        },
        xaxis: {
          type: "datetime",
          categories: calls?.data.categories,
        },
        legend: {
          position: "right",
          offsetY: 0,
          style: {
            foreColor: textColor,
            color: textColor,
            textColor: textColor,
          }
        },
        fill: {
          opacity: 1
        }
      }} series={calls?.data.series} type="bar" height={400} width={720} />;
    }
  });

  if (isLoading) {
    return <LoadingCenter color="primary" />;
  }

  return chart ? chart : null;
}

export default ApexChartDailyCalls;